import { Component } from '@angular/core';

@Component({
    selector: 'app-auth-header',
    templateUrl: './auth-header.component.html',
    styleUrls: ['./auth-header.component.css']
})

export class AdminHeaderComponent {



}
